import { useLayoutEffect } from 'react'

import { useAppStore } from '../../store/appStore/appStore'

/**
 * Sets the browser tab title for routes that are not driven by CMS `ViewConfig`.
 * The store appends ` - Helo`.
 */
export const SetDocumentTitle = ({ title }: { title: string }) => {
  useLayoutEffect(() => {
    useAppStore.getState().browserDocumentTitle.updateTitle({
      staticTitle: title,
      viewLabel: null,
      detailEntityDisplay: null,
      detailDrawerSuffix: null,
    })
    return () => {
      useAppStore.getState().browserDocumentTitle.resetForNavigation()
    }
  }, [title])

  return null
}
